export const FEATURE_NAME = '@zerops/zerops/core/recipe-base';
